/* eslint-disable */
import React from 'react';
import Layout from '../../components/Layout';
import Hero from './Hero/Hero';
import styles from './downloadApp.module.css';
import WhatsNew from './WhatsNew/WhatsNew';

const DownloadApp = () => (
  <Layout pageTitle="Download the App">
    <div className={styles.container}>
      <Hero/>
      <WhatsNew/>
    </div>
  </Layout>
);

export default DownloadApp;
